import Vue from 'vue'
import Router from 'vue-router'
import nprogress from 'nprogress';
import decode from 'jwt-decode';
import { ls } from '@/helpers';
import adminRoutes from './admin';
import provincialManagerRoutes from './provincial-manager';

const userTypeRoutes = {
  admin: adminRoutes,
  'provincial-manager': provincialManagerRoutes
}

Vue.use(Router)

let router;

const isLoggedIn = ls('token')!=null;

if (isLoggedIn) {
  const userType = decode(ls('token')).user.type;
  console.log(userType)
  const routes = userTypeRoutes[userType];

  router = new Router({
    routes
  });

  router.beforeEach((to, from, next) => {
    if (to.name) {
      nprogress.start();
    }
    next();
  })

  router.afterEach((to, from) => {
    nprogress.done();
  })
}



export default router;



// WEBPACK FOOTER //
// ./src/router/index.js